const getStatusFilterText = (status, defaultStatus) => {
  if (status && status[0]) {
    return status[0];
  }
  return defaultStatus[0];
};

export default getStatusFilterText;